import React from "react"
import { Container, Divider, Provider, Row } from "./Totals.styled"
import DineroFactory from "dinero.js"
import { OrderReleaseSearchTotals } from "lib/types/generated/graphql-types"
import Money from "../../../Money"

type Props = {
  totals: OrderReleaseSearchTotals
  currencyCode: string
}

const Totals = ({ totals, currencyCode }: Props) => (
  <Container>
    {totals.paymentTotal > 0 && (
      <Row>
        <Provider>Payment total</Provider>{" "}
        <Money
          amount={Math.round(totals.paymentTotal)}
          currencyUnit={currencyCode as DineroFactory.Currency}
        />
      </Row>
    )}
    {totals.bonusTotal > 0 && (
      <Row>
        <Provider>Bonus total</Provider>{" "}
        <Money
          amount={Math.round(totals.bonusTotal)}
          currencyUnit={currencyCode as DineroFactory.Currency}
        />
      </Row>
    )}
    {totals.giftCardTotal > 0 && (
      <Row>
        <Provider>Gift card total</Provider>{" "}
        <Money
          amount={Math.round(totals.giftCardTotal)}
          currencyUnit={currencyCode as DineroFactory.Currency}
        />
      </Row>
    )}
    {(totals.paymentTotal > 0 || totals.bonusTotal > 0 || totals.giftCardTotal > 0) && <Divider />}
    <Row>
      <h3>Release amount</h3>{" "}
      <h3>
        <Money
          amount={Math.round(totals.grandTotal)}
          currencyUnit={currencyCode as DineroFactory.Currency}
        />
      </h3>
    </Row>
  </Container>
)

export default Totals
